import * as React from 'react'
import { Link } from 'gatsby'

import { getIntlUrl } from 'src/utils/intl'
import LanguageContext from 'src/components/LanguageContext'

type Props = {
  to: string
  children: any
  onClick?: any
  className?: any
  ariaLabel?: string
}

class LinkComponent extends React.Component<Props> {
  render(): JSX.Element {
    const { to, children, onClick, className, ariaLabel } = this.props
    return (
      <LanguageContext.Consumer>
        {context => (
          <Link
            onClick={onClick}
            to={getIntlUrl(to, context.locale)}
            className={className}
            aria-label={ariaLabel}
          >
            {children}
          </Link>
        )}
      </LanguageContext.Consumer>
    )
  }
}

export default LinkComponent
